<template>
  <a-modal
    :title="isUpdate ? '修改功能' : '新增功能'"
    :width="640"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="false"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form-model ref="adminForm" :model="form" :label-col="{span:5}" :wrapper-col="{span:14}" autoComplete="off">
        <a-form-model-item v-show="false" label="ID" prop="id">
          <a-input v-model.number="form.id" />
        </a-form-model-item>
        <a-form-model-item v-show="false" label="PID" prop="pid">
          <a-input v-model.number="form.pid" />
        </a-form-model-item>
        <a-form-model-item label="父功能" prop="parentName">
          <a-input v-model="form.parentName" :disabled="true" />
        </a-form-model-item>
        <a-form-model-item label="功能名称" prop="name"
          :rules="[
            { required: true, message: '必填，不能为空', trigger: 'blur' },
            { validator: isExistName, trigger: 'blur' }
          ]">
          <a-input v-model="form.name" />
        </a-form-model-item>
        <a-form-model-item label="路由" prop="router"
          :rules="[
            { required: true, message: '必填，不能为空', trigger: 'blur' },
            { validator: isExistRouter, trigger: 'blur' }
          ]">
          <a-input v-model="form.router" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="seq"
          :rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
          <a-input v-model="form.seq" style="width:120px" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from "lodash.pick";
import { funcNameIsExist, funcRouterIsExist } from "@/api/system/func";

const fields = ['id', 'pid', 'parentName', 'name', 'router', 'seq'];

function emptyForm() {
  return {
    id: 0,
    pid: 0,
    parentName: 'root',
    name: '',
    router: '',
    seq: '50',
    apiUrls: ''
  };
}

export default {
  name: "FuncForm",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      form: emptyForm(),
    }
  },
  computed: {
    isUpdate: function() {
      return this.model && this.model.id > 0 ? true : false;
    }
  },
  created () {
    this.$watch('model', (m) => {
      if (!m) {
        this.initForm();
        return;
      }
      const base = pick(m, fields);
      if (base.seq !== undefined && base.seq !== null) {
        base.seq = String(base.seq);
      } else {
        base.seq = '50';
      }
      this.$nextTick(() => {
        this.form = { ...emptyForm(), ...base };
        if (this.$refs.adminForm) {
          this.$refs.adminForm.clearValidate();
        }
      });
    }, { immediate: true });
  },
  methods: {
    initForm() {
      this.form = emptyForm();
      this.$nextTick(() => {
        if (this.$refs.adminForm) {
          this.$refs.adminForm.clearValidate();
        }
      });
    },
    isExistName(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (this.model && this.model.name === value) {
        callback();
        return;
      }
      funcNameIsExist(value).then(res => {
        if (res.data) {
          callback(new Error('功能名称已存在'));
        } else {
          callback();
        }
      }).catch(() => callback());
    },
    isExistRouter(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (this.model && this.model.router === value) {
        callback();
        return;
      }
      funcRouterIsExist(value).then(res => {
        if (res.data) {
          callback(new Error('路由已存在'));
        } else {
          callback();
        }
      }).catch(() => callback());
    }
  }
}
</script>
